<div class="d-flex flex-column h-100">
	<div class="flex-grow-1 overflow-auto">
		<table
			class="w-100 table-fix-layout {{ type }}"
			[ngClass]="{
				'is-sticky-header': isStickyHeader,
				'is-head-hidden': isHideTableHead
			}"
		>
			<thead class="table-header visual-hidden" data-test-id="data-table-header">
				<th [style.width]="collapseCellWidth" class="header-cell">
					<mat-icon
						class="align-middle cursor-pointer expand-all-icon"
						*ngIf="isEnableGlobalCollapseButton"
						(click)="toggleAllRowCollapse()"
						>{{ isAllRowOpen ? 'unfold_less' : 'unfold_more' }}</mat-icon
					>
				</th>
				<th *ngFor="let column of adaptedColumns" [style.width]="column.width" class="header-cell">
					<div class="table-content">
						<ng-template
							[ngTemplateOutletContext]="{ column: column }"
							[ngTemplateOutlet]="column.headerTemplateRef"
						></ng-template>
					</div>
				</th>
			</thead>

			<tbody class="table-body">
				<ng-container
					*ngFor="let config of rowsConfigs$ | async; trackBy: changesTracker; let i = index; let isLastRow = last"
				>
					<ng-template *ngIf="!config.data && config.customTmpl" [ngTemplateOutlet]="config.customTmpl"></ng-template>
					<tr
						*ngIf="!!config.data"
						(click)="rowClickHandler(config)"
						[ngClass]="{
							'expanded-background': isRowCanCollapse(config.id) && !isRowCollapsed[config.id],
							'hover-disable': !isRowCanCollapse(config.id),
							'cursor-pointer': isRowCanCollapse(config.id)
						}"
						[class]="'table-row ' + (!!customRowClassesFn ? customRowClassesFn(config.data) : '')"
					>
						<td class="table-cell" [style.width]="collapseCellWidth">
							<mat-icon
								data-test-id="grid-collapse-btn"
								class="align-middle expand-icon"
								*ngIf="isRowCanCollapse(config.id)"
								[class.expand-icon__open]="isRowCollapsed[config.id]"
								>keyboard_arrow_up
							</mat-icon>
						</td>
						<td *ngFor="let column of adaptedColumns" [style.width]="column.width" class="table-cell">
							<ng-template
								[ngTemplateOutletContext]="{
									value: column.prop ? getValue(config.data, column.prop) : null,
									column: column,
									row: config.data
								}"
								[ngTemplateOutlet]="column.cellTemplateRef"
							></ng-template>
						</td>
					</tr>
					<tr [hidden]="!isRowCanCollapse(config.id) || isRowCollapsed[config.id]">
						<td [attr.colspan]="columnsCount" class="p-0 border-bottom-0 {{ isRowCollapsed[config.id] ? 'h-0' : '' }}">
							<ng-template [ngTemplateOutlet]="config.collapsibleTemplateRef!"></ng-template>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
	<div class="flex-grow-0 d-block my-3 ml-auto" *ngIf="pageSize < totalCount">
		<app-pagination
			[currentPage]="page"
			[itemsCount]="totalCount"
			[pageSize]="pageSize"
			(configChanged)="changePagination($event)"
		>
		</app-pagination>
	</div>
</div>

<div *appCustomCell="customHeaderCells.sorting; let column = column">
	<app-sort-header [column]="column" [filter]="listAdapter?.filters"></app-sort-header>
</div>

<div *appCustomCell="customHeaderCells.simple; let column = column" class="text-truncate" appFullTextTooltip>
	{{ column.name }}
</div>

<div *appCustomCell="customRowCells.simple; let value = value; let row = row" class="text-truncate" appFullTextTooltip>
	{{ value | emptyValue }}
</div>

<div *appCustomCell="customRowCells.date; let value = value; let row = row" class="text-truncate" appFullTextTooltip>
	{{ value | date : 'MM/dd/yyyy' | emptyValue }}
</div>

<div
	*appCustomCell="customRowCells.percentage; let value = value; let row = row"
	class="text-truncate"
	appFullTextTooltip
>
	{{ value | percent | emptyValue }}
</div>

<div *appCustomCell="customRowCells.price; let value = value; let row = row" class="text-truncate" appFullTextTooltip>
	{{ value | currency | emptyValue }}
</div>

<div *appCustomCell="customRowCells.boolean; let value = value; let row = row" class="text-truncate" appFullTextTooltip>
	<app-tip-boolean [value]="value"></app-tip-boolean>
</div>
